import { render, staticRenderFns } from "./ResultsView.vue?vue&type=template&id=6a7f66b2"
import script from "./ResultsView.vue?vue&type=script&lang=ts"
export * from "./ResultsView.vue?vue&type=script&lang=ts"
import style0 from "./ResultsView.vue?vue&type=style&index=0&id=6a7f66b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports